import type { ReactNode } from 'react'

export const CommentsListSkeleton = (): ReactNode => (
  <div className="space-y-5 md:space-y-6" role="status" aria-label="Loading Comments">
    {Array.from({ length: 3 }).map((_, i) => (
      <div key={i} className="animate-pulse" aria-hidden="true">
        <div className="flex w-full flex-row items-start gap-2.5 sm:gap-2.5">
          <div className="size-10 rounded-full bg-skeleton-primary" />

          <div className="relative w-[calc(100%-40px)] min-w-0 grow-0 rounded-xl">
            <div className="relative rounded-xl p-[15px]">
              <div className="mb-3 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="h-4 w-20 rounded-sm bg-skeleton-primary" />
                  <div className="h-3 w-16 rounded-sm bg-skeleton-primary" />
                </div>
              </div>

              <div className="space-y-2">
                <div className="h-4 w-full rounded-sm bg-skeleton-primary" />
                <div className="h-4 w-3/4 rounded-sm bg-skeleton-primary" />
                <div className="h-4 w-1/2 rounded-sm bg-skeleton-primary" />
              </div>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
)
